import RequestService from './Request'


var get = (id) => {
	return new Promise((resolve, reject) => {
		var req = {
			url: '/public/banner/' + id,
			method: 'GET',
			addToken: false
		}
		RequestService.send(req).then(
			res => {
				return resolve(res)
			},
			err => {
				return reject(err)
			}
		)
	})
}

var getAvailable = () => {
	return new Promise((resolve, reject) => {
		var req = {
			url: '/public/banner',
			method: 'GET',
			addToken: false
		}
		RequestService.send(req).then(
			res => {
				return resolve(res)
			},
			err => {
				return reject(err)
			}
		)
	})
}

var withRouteExtension = (routeExtension) => {
	return new Promise((resolve, reject) => {
		var req = {
			url: '/public/banner/',
			method: 'PUT',
			body: {
				routeExtension
			},
			addToken: false
		}
		RequestService.send(req).then(
			res => {
				return resolve(res)
			},
			err => {
				return reject(err)
			}
		)
	})
}


var withPagination = (itemsPerPage = undefined, pageIndex = undefined ) => {
	return new Promise((resolve, reject) => {
		var req = {
			url: '/public/banner',
			method: 'POST',
			body: {
				pagination: {
					itemsPerPage,
					pageIndex
				}
			},
			addToken: false
		}
		RequestService.send(req).then(
			res => {
				return resolve(res)
			},
			err => {
				return reject(err)
			}
		)
	})
}

export default {
	get, getAvailable, withPagination, withRouteExtension
}
